/* loading-error.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./loading-error.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import { fontFallback } from '@atlaskit/theme/typography';
import { useDatasourceAnalyticsEvents } from '../../../analytics';
import { SpotErrorSearch } from '../../../common/ui/spot/error-state/search';
import { LoadingErrorOld } from './loading-error-old';
import { LoadingErrorSVGOld } from './loading-error-svg-old';
import { loadingErrorMessages } from './messages';
var styles = {
  errorContainerStyles: "_zulppxbi _4cvr1h6o _6a6z1h6o _1wpz1h6o _10fp1h6o _1e0c11p5",
  errorMessageContainerStyles: "_zulpu2gc _4cvr1h6o _6a6z1h6o _1e0c11p5",
  errorMessageStyles: "_11c8nbxd"
};
export var LoadingErrorNew = function LoadingErrorNew(_ref) {
  var onRefresh = _ref.onRefresh;
  var _useDatasourceAnalyti = useDatasourceAnalyticsEvents(),
    fireEvent = _useDatasourceAnalyti.fireEvent;
  useEffect(function () {
    fireEvent('ui.error.shown', {
      reason: 'network'
    });
  }, [fireEvent]);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.errorContainerStyles,
    testId: "datasource--loading-error"
  }, fg('bandicoots-update-sllv-icons') ? /*#__PURE__*/React.createElement(SpotErrorSearch, {
    size: 'xlarge',
    alt: ""
  }) : /*#__PURE__*/React.createElement(LoadingErrorSVGOld, null), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.errorMessageContainerStyles
  }, /*#__PURE__*/React.createElement(Inline, {
    as: "span",
    xcss: styles.errorMessageStyles
  }, /*#__PURE__*/React.createElement(FormattedMessage, loadingErrorMessages.unableToLoadItems)), /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, /*#__PURE__*/React.createElement(FormattedMessage, loadingErrorMessages.checkConnection)), onRefresh && /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    onClick: onRefresh
  }, /*#__PURE__*/React.createElement(FormattedMessage, loadingErrorMessages.refresh))));
};
export var LoadingError = function LoadingError(props) {
  if (fg('bandicoots-compiled-migration-link-datasource')) {
    return /*#__PURE__*/React.createElement(LoadingErrorNew, props);
  } else {
    return /*#__PURE__*/React.createElement(LoadingErrorOld, props);
  }
};